import { useDispatch } from 'react-redux'
import {globalEventSettingsFetcher} from "./events/useFetchEvtSettings";
import {EvtState, setEvt, useEvtState} from "../slices/evtSlice";
import {useEffect} from "react";

export const useAutoEvt = (eventId: string) => {
  const eventState = useEvtState()
  const dispatch = useDispatch()

  useEffect(() => {
    globalEventSettingsFetcher(Number(eventId)).then((data) => {
      if (data) {
        console.log(data)
        const newState: EvtState = {
          eventId: data?.eventid?.toString(),
          eventName: data.name,
          eventCode: data.code,
          allowpaymentoffees: data?.allowpaymentoffees,
          ccfee: data?.ccfee
        }
        dispatch(setEvt(newState))
      }
    })
  }, [eventId])

  // if (Number(eventState.eventId) != Number(eventId) && Number(eventId) > 0 && Number(eventState.eventId) == 0) {
  //   console.log('Updating')
  //   console.log(eventId)
  //   console.log(Number(eventState.eventId))
  //   globalEventSettingsFetcher(Number(eventId)).then((data) => {
  //     if (data) {
  //       console.log(data)
  //       const newState: EvtState = {
  //         eventId: data?.eventid?.toString(),
  //         eventName: data.name,
  //         eventCode: data.code,
  //         allowpaymentoffees: data?.allowpaymentoffees,
  //         ccfee: data?.ccfee
  //       }
  //       dispatch(setEvt(newState))
  //     }
  //   })
  // }
}
